import { ImageWithMagnifier } from '@/components/image-with-magnifier/image-with-magnifier'

import { cn } from '@/lib/utils'

export interface DocumentImagesProps {
  currentPage: number
  imgUrls: string[]
}

export const DocumentImages = ({ currentPage, imgUrls }: DocumentImagesProps) => {
  return (
    <div className={cn('relative', 'w-full')}>
      {imgUrls.map((imgUrl, index) => (
        <ImageWithMagnifier
          key={index}
          src={imgUrl}
          className={{
            root: cn('absolute left-[50%] top-0 translate-x-[-50%]', 'w-[780px]', {
              visible: index === currentPage - 1,
              invisible: index !== currentPage - 1,
            }),
          }}
        />
      ))}
    </div>
  )
}
